<h2 class="sectionTitle"></h2>
 <div class="row" *ngIf="model != null">
  <div class="col-md-3 col-md-push-9 col-xs-12">
    <div class="tender-box-holder">
      <!-- <div class="tender-box">
        <button type="button" class="btn btn-primary SCAcustomBtn">Ask a Question</button>
      </div> -->
      <p class="tender-box" *ngIf="model.BookletPrice != null">
        <span class="name">{{'ADMIN_USER.E_TENDER_FORM.BOOKLET_PRICE'|translate}}</span>
        <span class="price">{{model.BookletPrice}} LE</span>
      </p>
      <p class="tender-box">
        <span class="name">{{'ADMIN_USER.E_TENDER_FORM.INSURANCE_VALUE'|translate}}</span>
        <span class="price">{{model.InsuranceValue}} LE</span>
      </p>
      <p class="tender-box" *ngIf="model.BookletCopy != ''">
        <a target="_blank" [href]=[model.BookletCopy]>{{'ADMIN_USER.E_TENDER_FORM.BOOKLET'|translate}}</a>
      </p>
    </div>
  </div>
  <div class="col-md-9 col-md-pull-3 col-xs-12">
    <div class="tender-info-holder">
      <div>
        <span class="icon-calendar"></span>
        <p>{{model.Date}}</p>
      </div>
      <div>
        <span class="icon-clock"></span>
        <p>{{model.Time}}</p>
      </div>
      <div>
        <span class="icon-map-pin"></span>
        <p>{{model.SessionPlace}}</p>
      </div>
    </div>
    <div class="tender-body-info">
      <p>{{model.Title}}</p>
      <div class="form-container">
        <h4 class="section-title">{{'ADMIN_USER.E_TENDER_FORM.TERMS_CONDITION'|translate}}</h4>
      </div>
      <p>{{model.GeneralTerms}}</p>
    </div>
  </div>
</div>
